import type { UseMutationResult } from "@tanstack/react-query";
import type {
  TradeOption,
  FetchTradesResult,
  TradeSelectionMeta,
} from "@simplybusiness/mobius-trade-selector";
import { LoadingState } from "./LoadingState";
import { TradesListState } from "./TradesListState";

export const TradesResults = ({
  mutation,
  variant,
  onTradeSelect,
}: {
  mutation: UseMutationResult<
    FetchTradesResult<TradeOption[]>,
    Error,
    string,
    unknown
  >;
  variant: "default" | "ai";
  onTradeSelect: (trade: TradeOption, meta: TradeSelectionMeta) => void;
}) => {
  if (mutation.isPending) {
    return <LoadingState />;
  }

  if (!mutation.isSuccess) {
    return null;
  }

  const trades = mutation.data?.results;
  const searchId = mutation.data?.searchId;

  if (!trades || trades.length === 0) {
    return null;
  }

  return (
    <TradesListState
      trades={trades}
      searchId={searchId}
      variant={variant}
      onTradeSelect={onTradeSelect}
    />
  );
};
